;(() => {
	let bannerGridSlider

	const initSlider = (slider) => {
		slider.classList.add('swiper')

		const wrapper = slider.querySelector('.banner-grid__grid')

		if (!wrapper) return

		wrapper.classList.add('swiper-wrapper')

		const slides = slider.querySelectorAll('.banner-grid__card')

		if (!slides || !slides.length) return

		slides.forEach((slide) => {
			slide.classList.add('swiper-slide')
		})

		bannerGridSlider = new Swiper(slider, {
			loop: false,
			slidesPerView: 1.1,
			spaceBetween: 16,
			speed: 1000,
			mousewheel: {
				forceToAxis: true,
			},
		})
	}

	const destroySlider = (section) => {
		if (!section || !section?.classList.contains('banner-grid-section')) return

		const slider = section.querySelector('.banner-grid-slider')
		const slides = section.querySelectorAll('.banner-grid__card')
		const wrapper = section.querySelector('.banner-grid__grid')

		if (!slider || !slides || !slides.length || !wrapper) return

		slider.classList.remove('swiper')

		slides.forEach((slide) => {
			slide.classList.remove('swiper-slide')
		})

		wrapper.classList.remove('swiper-wrapper')

		bannerGridSlider.destroy(true, true)
		bannerGridSlider = null
	}

	const calcHeightButton = (section, width) => {
		let parent
		if (document.currentScript) {
			parent = document.currentScript.parentElement
		} else {
			parent = section
		}

		const cards = parent.querySelectorAll('.banner-grid__card_full-link')
		cards.forEach((card) => {
			const button = card.querySelector('.banner-grid__button')
			let heightButton
			if (button && width >= 750) {
				heightButton =
					button.getBoundingClientRect().height +
					parseFloat(
						window.getComputedStyle(button, null).getPropertyValue('margin-top')
					)
			} else {
				if (width < 750) heightButton = 16
				else heightButton = 24
			}

			card.style = `--height-button: ${heightButton}px`
			if (card.querySelector('.banner-grid__top')) {
				card.querySelector('.banner-grid__top').style.marginBottom =
					heightButton + 'px'
			} else if (card.querySelector('.banner-grid__title-content')) {
				card.querySelector('.banner-grid__title-content').style.marginTop =
					heightButton + 'px'
			}
		})
	}

	const initSection = (section) => {
		let sectionBannerGrid

		if (document.currentScript) {
			sectionBannerGrid = document.currentScript.parentElement
		} else {
			sectionBannerGrid = section
		}

		if (!sectionBannerGrid) return

		const slider = sectionBannerGrid.querySelector('.banner-grid-slider')

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries

			calcHeightButton(sectionBannerGrid, entry.contentRect.width)

			if (entry.contentRect.width < 576 && slider) {
				initSlider(slider)
			} else if (bannerGridSlider) {
				destroySlider(sectionBannerGrid)
			}
		})

		sectionResizeObserver.observe(sectionBannerGrid)
	}

	initSection()

	document.addEventListener('shopify:section:load', function (section) {
		initSection(section.target)
	})

	const initVideoModal = (root = document) => {
    const modal = document.getElementById('videoModal')
    const wrapper = document.getElementById('video-swiper-wrapper')
    const closeBtn = modal?.querySelector('.video-modal__close')

    if (!modal || !wrapper || !closeBtn) return

    const cards = root.querySelectorAll('.banner-grid__card')
    if (!cards.length) return

    // 避免重复初始化
    if (modal.dataset.videoModalInit === 'true') return
    modal.dataset.videoModalInit = 'true'

    let swiperInstance = null

    const buildSlides = () =>
      Array.from(cards).map((card) => {
        const video = card.dataset.video
        const title = card.dataset.title
        const category = card.dataset.category

        return `
          <div class="swiper-slide">
            <video controls autoplay muted playsinline>
              <source src="${video}" type="video/mp4">
            </video>
            <div class="video-info">
              <div class="video-category">${category || ''}</div>
              <div class="video-title">${title || ''}</div>
            </div>
          </div>
        `
      })

    const openAt = (index) => {
      wrapper.innerHTML = buildSlides().join('')
      modal.classList.remove('hidden')

      if (swiperInstance) swiperInstance.destroy(true, true)

      swiperInstance = new Swiper('.video-swiper', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        initialSlide: index,
      })
    }

    cards.forEach((card, index) => {
      // 避免重复绑定点击
      if (card.dataset.videoCardBind === 'true') return
      card.dataset.videoCardBind = 'true'

      card.addEventListener('click', () => openAt(index))
    })

    closeBtn.addEventListener('click', () => {
      modal.classList.add('hidden')
      wrapper.innerHTML = ''
      if (swiperInstance) swiperInstance.destroy(true, true)
      swiperInstance = null
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    initVideoModal(document)
  })

  document.addEventListener('shopify:section:load', (event) => {
    // 编辑器里动态加载 section 时也能用
    initVideoModal(event.target)
  })

})()
